import { PropsWithChildren } from "react";
import { lightBulb } from "../../client-utils/icons.js";

type StatusVariant = "info" | "error" | "success";

interface Props {
  title: string;
  variant: StatusVariant;
}

export const StatusBox: React.FC<PropsWithChildren<Props>> = ({
  title,
  variant = "info",
  children,
}) => {
  let iconElement: React.ReactNode = lightBulb;

  switch (variant) {
    case "info":
      iconElement = lightBulb;
      break;
    default:
      iconElement = null;
  }

  return (
    <div className={`status-box status-${variant}`}>
      <div className="head">
        {iconElement} <h3>{title}</h3>
      </div>
      {children && <div className="body">{children}</div>}
    </div>
  );
};
